<?xml version="1.0" encoding="UTF-8" standalone="no"?>
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg width="100%" height="100%" viewBox="0 0 67 67" version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve"
  xmlns:serif="http://www.serif.com/" stroke-width="4" stroke="currentColor" style="fill-rule:evenodd;clip-rule:evenodd;">
  <path d="M2.083,4.167l0,22.083c0,0.417 0.417,1.25 0.417,1.667l35.417,35.416c0.833,0.834 2.083,0.834 2.916,0l22.084,-22.083c0.833,-0.833 0.833,-2.083 -0,-2.917l-35.417,-35.833c0,0 -0.833,-0.417 -1.25,-0.417l-22.083,0c-1.25,0 -2.084,0.834 -2.084,2.084Z" style="fill:none"/>
  <circle cx="16.667" cy="16.667" r="4.167" fill="currentColor" style="stroke:none;" />
  <circle cx="23.075" cy="49.69" r="16.669" style="stroke:none;" />
  <g>
    <path d="M16.915,55.182l10.985,-10.985" style="stroke:#fff"/>
    <path d="M27.9,44.197l0,10.134" style="stroke:#fff;stroke-linecap:round;"/>
    <path d="M27.9,44.197l-9.921,0" style="stroke:#fff;stroke-linecap:round;"/>
  </g>
</svg>
